/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_KindsInputs */

const en_notify_kinds = /** @type {(inputs: Notify_KindsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What`)
};

const de_notify_kinds = /** @type {(inputs: Notify_KindsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was`)
};

/**
* | output |
* | --- |
* | "What" |
*
* @param {Notify_KindsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_kinds = /** @type {((inputs?: Notify_KindsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_KindsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_kinds(inputs)
	return en_notify_kinds(inputs)
});